import React from 'react'

import { Instructions } from '@/components/forms/VoipCampaignCSVUploadForms/Instructions'
import Receipt from '@/components/forms/VoipCampaignCSVUploadForms/Receipt'
import MultiStepForm from '@/views/Organizations/MultiStepForm'
import { Preview } from '@/components/forms/VoipCampaignCSVUploadForms/Preview'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'

export const BulkVoipCampaignUploadButton = ({ organizationId }) => {
  return (
    <BasicModal
      trigger={(handleOpen) => (
        <Button brand onClick={handleOpen} data-testid="bulk-voip-campaign-upload-default">
          Bulk VoIP Campaign Upload
        </Button>
      )}
      title="Bulk VoIP Campaign Upload"
    >
      <MultiStepForm
        organizationId={organizationId}
        steps={[
          <Instructions organizationId={organizationId} />,
          <Preview organizationId={organizationId} />,
          <Receipt />,
        ]}
      />
    </BasicModal>
  )
}
